export default __webpack_public_path__ + "static/media/HomePage IMG.5f8eebb8.png";